module.exports = __webpack_public_path__ + "img/img-2.fd290ee0.png";